function changeGroupField(state, reducerAction ) {
  const {endpointId, index, field, value, action, group} = reducerAction.payLoad;

	return {
		...state,
		settings: {
			...state.settings,
			endpoints: [
				...state.settings.endpoints.map((el, endpointIndex) => {
					if ( endpointIndex === endpointId ) {
						el[action][0][group][index][field] = value
					}
					return el;
				}),
			]
		}
	};
}

export { changeGroupField };
